import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

const MyTeam = (props) => (
  <Svg
    width={32}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#a)" fill="#5FAFFF">
      <Path d="M16 13.693c2.293 0 4.16-1.866 4.16-4.146s-1.867-4.16-4.16-4.16a4.165 4.165 0 0 0-4.16 4.16A4.154 4.154 0 0 0 16 13.693ZM17.28 14.387h-2.56c-4.253 0-7.72 3.466-7.72 7.72v2.746c0 1.12.907 2.027 2.027 2.027h13.946c1.12 0 2.027-.907 2.027-2.027v-2.746c0-4.254-3.467-7.72-7.72-7.72Z" />
      <Path d="M7.213 16.52a3.187 3.187 0 1 0 0-6.373 3.187 3.187 0 0 0 0 6.373ZM24.973 16.52a3.187 3.187 0 1 0 0-6.373 3.187 3.187 0 0 0 0 6.373ZM2.64 22.987v2.56c0 .733.627 1.333 1.387 1.333h1.72v-4.573a8.64 8.64 0 0 1 1.426-4.787c-2.626.787-4.533 2.92-4.533 5.467ZM24.973 17.52a8.75 8.75 0 0 1 1.427 4.787v4.573h1.72c.773 0 1.387-.6 1.387-1.333v-2.56c0-2.547-1.907-4.68-4.534-5.467Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h32v32H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default MyTeam
